<template>
  <div class="def-list-tile list-tile"
       :class="{active: active }"
       @click="e => mapStore.onDefClick(def)">
    <p class="title">{{ def.titleShown}}</p>
    <p class="subtitle">{{ def.author }} {{ def.firstAuthor }}</p>
  </div>
</template>
<script lang="ts">
import {computed, defineComponent, inject, PropType} from "vue";
import {IDefinition} from "@/interfaces/evidence-map";
import {useMapStore} from "@/mixins/mapStore";

export default defineComponent({
  name: "DefListTile",
  props: {
    def: {
      type: Object as PropType<IDefinition>,
      required: true
    }
  },
  setup(props) {
    const mapStore = useMapStore()
    const active = computed(() => mapStore.state.def?.id == props.def.id)
    return {
      mapStore,
      active
    }
  }
})
</script>